import { Injectable } from '@angular/core';
import { DcFeatures, OperationalDataApiModel } from './operational-data.model';
import { Observable, of } from 'rxjs';
import { MockedDevicesFeatures } from './operational-data.mocks';
import { ConfigurationStore } from '../../../../app/@store';

@Injectable({ providedIn: 'root' })
export class OperationalDataMockApi implements OperationalDataApiModel {
  private baseMockUrl =
    'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations';
  private baseUri: string;

  constructor(private configurationStore: ConfigurationStore) {
    this.configurationStore.selectFeaturesBaseUri$.subscribe((uri) => {
      this.baseUri = uri;
    });
  }

  listAllGatewayFeatures(_installationId: number, _gatewaySerial: string): Observable<DcFeatures> {
    let mock = new MockedDevicesFeatures().mock(_installationId, _gatewaySerial);

    const mockUriMapped = (<unknown>{
      data: mock.data.map((feature) => {
        return {
          ...feature,
          uri: feature.uri.replace(this.baseMockUrl, this.baseUri),
        };
      }),
    }) as DcFeatures;

    return of(mockUriMapped);
  }
}
